/* eslint-disable */

import React, { Component } from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { GhostButton } from 'common-components/buttons';
import { IInviteWorker } from 'interfaces/user-interfaces';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const { Option } = Select;

interface IInviteWorkerDetailRowProps extends FormComponentProps {
  rowKey: number;
  workerInputItem: IInviteWorker;
  handleDelete: (rowKey: number) => void;
  handleInputClick: (string) => void;
  handleDropDownClick: (string, number, name: string) => void;
}

class InviteSupportWorkerDetailRow extends Component<IInviteWorkerDetailRowProps, any> {
  componentDidUpdate = (prevProps) => {
    if (prevProps.workerInputItem !== this.props.workerInputItem) {
      const { workerInputItem } = this.props;
      // set antd form to latest value
      const fieldValues: any = {
        firstName: workerInputItem.firstName,
        lastName: workerInputItem.lastName,
        role: workerInputItem.role,
        phoneNumberCountryCode: workerInputItem.phoneNumberCountryCode,
        phoneNumber: workerInputItem.phoneNumber,
        email: workerInputItem.email,
      };

      this.props.form.setFieldsValue(fieldValues);
    }
  };

  private _removeWorkerInputRow = (i) => {
    this.props.handleDelete(i);
  };

  private _handleInputClick = (event) => {
    this.props.handleInputClick(event);
  };

  private _handleRoleClick = (event) => {
    this.props.handleDropDownClick(event, this.props.rowKey, 'role');
  };

  private _handleCountryCodeClick = (event) => {
    this.props.handleDropDownClick(event, this.props.rowKey, 'phoneNumberCountryCode');
  };

  private _validateMobileNumber = (rule, value, callback) => {
    const region = 'AU';
    let phoneNumber = parsePhoneNumberFromString(value, region);
    try {
      if (!phoneNumber.isValid()) {
        throw new Error('Invalid Number');
      }
    } catch (err) {
      callback(err);
      return;
    }
    callback();
  };

  render() {
    const { form, workerInputItem } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Row gutter={16}>
        <Col span={4}>
          <Form.Item>
            {getFieldDecorator('firstName', {
              rules: [{ required: true, message: 'First name is required' }],
              initialValue: workerInputItem.firstName,
            })(<Input onChange={this._handleInputClick} name="firstName" size="large" style={{ fontSize: '16px' }} />)}
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            {getFieldDecorator('lastName', {
              rules: [{ required: true, message: 'Last Name is required' }],
              initialValue: workerInputItem.lastName,
            })(<Input onChange={this._handleInputClick} name="lastName" size="large" style={{ fontSize: '16px' }} />)}
          </Form.Item>
        </Col>
        <Col span={7}>
          <Row type={'flex'} gutter={4}>
            <Col span={9}>
              <Form.Item>
                {getFieldDecorator('phoneNumberCountryCode', {
                  rules: [{ required: true, message: 'Country code is required' }],
                  initialValue: workerInputItem.phoneNumberCountryCode,
                })(
                  <Select
                    dropdownMatchSelectWidth={true}
                    onChange={this._handleCountryCodeClick}
                    disabled={true}
                    size="large"
                    style={{ fontSize: '16px' }}
                  >
                    <Option value={'AU'}>+61 (AU)</Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={15}>
              <Form.Item>
                {getFieldDecorator('phoneNumber', {
                  initialValue: workerInputItem.phoneNumber,
                  rules: [
                    { required: true, message: 'Mobile number is required' },
                    {
                      validator: this._validateMobileNumber,
                      message: 'Invalid Mobile number.',
                    },
                  ],
                })(
                  <Input
                    style={{ fontSize: '16px' }}
                    size="large"
                    className={'width-full'}
                    name={'phoneNumber'}
                    onChange={this._handleInputClick}
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={4}>
          <Form.Item>
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'Please enter valid Email',
                },
                {
                  required: true,
                  message: 'Email is required',
                },
              ],
            })(<Input onChange={this._handleInputClick} name="email" size="large" style={{ fontSize: '16px' }} />)}
          </Form.Item>
        </Col>
        <Col span={4}>
          <div className="flex-row">
            <Form.Item>
              {getFieldDecorator('role', {
                rules: [{ required: true, message: 'Worker role is required' }],
                initialValue: workerInputItem.role,
              })(
                <Select
                  dropdownMatchSelectWidth={true}
                  onChange={this._handleRoleClick}
                  size="large"
                  style={{ fontSize: '16px' }}
                >
                  <Option value="">Please select role</Option>
                  <Option value={'worker'}>Support Worker</Option>
                  <Option value={'volunteer'}>Volunteer</Option>
                  <Option value={'manager'}>Manager</Option>
                  <Option value={'other'}>Other</Option>
                </Select>,
              )}
            </Form.Item>
            <Form.Item>
              <GhostButton
                icon="close"
                size="large"
                paddingSize="medium"
                className="ml-small"
                color="black"
                onClick={() => this._removeWorkerInputRow(this.props.rowKey)}
              />
            </Form.Item>
          </div>
        </Col>
      </Row>
    );
  }
}

export default Form.create<IInviteWorkerDetailRowProps>()(InviteSupportWorkerDetailRow);
